import { mockBuilder } from '../../utils/builderHelper.es.js';
import { aPrice } from '../Price.mock.es.js';
import '../../enums/billing/AccountGlobalStatusEnum.es.js';
import '../../enums/billing/AccountingStatusEnum.es.js';
import '../../enums/billing/AssetPurchaseFormatEnum.es.js';
import '../../enums/billing/AssetPurchaseUnavailableCodeEnum.es.js';
import '../../enums/billing/BillingSystemEnum.es.js';
import '../../enums/billing/CreditKindEnum.es.js';
import { InvoiceStatusEnum } from '../../enums/billing/InvoiceStatusEnum.es.js';
import '../../enums/billing/DiscountTypeEnum.es.js';
import '../../enums/billing/PlanFrequencyEnum.es.js';
import '../../enums/billing/ServiceOffersKindEnum.es.js';
import '../../enums/billing/ServiceStatusEnum.es.js';
import '../../enums/billing/SubscriptionStatusEnum.es.js';
import '../../enums/billing/SubscriptionMigrationTypeEnum.es.js';
import '../../enums/billing/SubscriptionMigrationTimingEnum.es.js';
import '../../enums/billing/SubscriptionServiceOfferEnum.es.js';
import '../../enums/billing/BillingCommitmentEnum.es.js';
import { InvoiceListItem } from './InvoiceListItem.es.js';

/** @module Mocks */ /** typedoc */
// Section: Invoice
function anInvoiceListItem() {
    return mockBuilder(new InvoiceListItem())
        .withId('666')
        .withDate('2018-12-03T22:23:22Z')
        .withAmount(aPrice().withValue(99.99).withCurrencyCode('USD').withCurrencySymbol('$'))
        .withStatus(InvoiceStatusEnum.Paid);
}

export { anInvoiceListItem };
